<template>
  <div>
    <el-header>
      <div class="header-container">
        <div class="center-content">
          <a href="/" class="main-text">BLOG</a>
          <a href="/FZSRwgKeoi3DbOkJrZncPZP9nng" class="side-text">关于</a>
          <a href="/D7X1wVwGSi6yuokhXZRcFVOMnbe" class="side-text">求职导航</a>
        </div>
      </div>
    </el-header>
    <br>
  </div>
</template>

<script>
export default {
  name: "JjeHeader",
  components: {

  },
}
</script>

<style scoped>
/* CSS 重置 */
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

/* 固定头部样式 */
.el-header {
  /*background: black;*/
  position: fixed;
  top: 0px;
  left: 0;
  right: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, .1); /* 添加阴影效果 */
  z-index: 1000; /* 确保它在其他元素之上 */
  height: 120px; /* 根据需要设置高度 */
  width: 100%;
  display: flex;
  align-items: center; /* 垂直居中 */
}

/* 包裹容器样式 */
.header-container {
  max-width: 1000px; /* 与父容器相同 */
  margin: 0 auto; /* 确保居中 */
  padding: 0 50px; /* 可选：为内容添加一些内边距 */
  width: 100%;
  display: flex;
  background: url('@/assets/images/jje-header.gif') no-repeat right 40px center / contain ; /* 设置背景图片，默认为靠右居中 */
  justify-content: space-between; /* 文字靠左，图片靠右 */
  align-items: center; /* 垂直居中 */
}

/* 内容区域样式 */
.center-content {
  margin-top: 30px; /* 确保居中 */
  display: flex;
  color: white;
  justify-content: flex-start; /* 靠近最左边 */
  align-items: baseline; /* 底部对齐 */
  gap: 4em; /* 调整项目之间的间距 */
}

.side-text,
.main-text {
  text-decoration: none; /* 移除下划线 */
  color: inherit; /* 继承父级颜色 */
  text-shadow:
      1px 1px 0 #000,   /* 左上 */
      1px 1px 0 #000,   /* 右上 */
      1px 1px 0 #000,    /* 左下 */
      1px 1px 0 #000;    /* 右下 */
}

.side-text {
  font-size: 16px; /* 设置旁边文字的小字体大小 */
}

.main-text {
  font-size: 26px; /* 设置中间文字的大字体大小 */
}

/* 移动端背景图调整 */
@media (max-width: 768px) {
  .header-container {
    background-size: 38%; /* 背景图片在移动端缩小到80% */
    background-position: right 0px  bottom 0px ; /* 可选：调整背景图片位置以适应更小的空间 */
    padding: 0 3px; /* 减少内边距 */
  }

  .center-content{
    gap: 0.7em; /* 调整项目之间的间距 */
  }


}



</style>
